module.exports = __webpack_public_path__ + "static/img/biankuang.ebf02d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/biankuang.png
// module id = W1ec
// module chunks = 2